import type { JSX, ReactNode } from 'react';
import './PageFrame.css';

interface PageFrameProps {
  children: ReactNode;
}

/**
 * Page-layout frame for every Susdle surface: full-height flex column with
 * the page-margin paper band and a centered content well.
 *
 * Renamed from OrnamentalBorder when the ornament was deleted as dead code
 * (2026-06: every call site passed chrome='bare'; the twin page-rules and
 * foliate corner SVGs had zero live renders). The hand-drawn corner artwork
 * survives in git history under OrnamentalBorder.tsx if a standalone-page
 * look ever returns. The footnotes slot went with it — Settings chrome is
 * now the App-level fixed-position MetaControls, which needs no slot.
 */
export function PageFrame({ children }: PageFrameProps): JSX.Element {
  return (
    <div className="susdle-page-frame">
      <div className="susdle-page-frame__inner">{children}</div>
    </div>
  );
}
